import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import RectangleFormStyle from './RectangleFormStyle'
import type { RectangleFormBrandType, RectangleBrandForms } from './rectangleTypes'

const FORM_MAP: RectangleBrandForms = {
  [BrandFormEnum.STYLE]: RectangleFormStyle,
}

const RectangleFormBrand: RectangleFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(RectangleFormBrand) as typeof RectangleFormBrand
